import { Button, message } from "antd";
import { useEffect, useState, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import BasicLayout from "../../../components/BasicLayout";
import FallBack from "../../../components/common/FallBack/FallBack";
import Tables from "../../../components/common/Table/Table";
import { useDeleteAction } from "../../../components/Hooks/useDeleteAction";
import useExportCsv from "../../../components/Hooks/useExportCsv";
import useTableSearch from "../../../components/Hooks/useTableSearch";
import {
	getApplication,
	softDeleteSingleApplication,
} from "../../../store/actions/Careers/careers.action";
import { DeleteModel } from "../../../utils/DeleteModel";
import { convertEpochToDate, formatFileName } from "../../../utils/helper";
import "./index.css";

const Applications = (props) => {
	const [getColumnSearchProps] = useTableSearch();
	const dispatch = useDispatch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const applications = useSelector((state) => state.careers.applications || []);

	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getApplication());
	}, [dispatch]);

	let dataSource = [];
	if (applications.length > 0) {
		dataSource = applications.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});

		dataSource = dataSource.map((row, index) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			key: row.id,
			status: row.status ? "Yes" : "no",
			availableAfter: convertEpochToDate(row.availableAfter),
			appliedFor: row.job ? row?.job?.position : "",
		}));
	}

	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteSingleApplication, setIsModalVisible);
	}
	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			...getColumnSearchProps("name"),
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			...getColumnSearchProps("email"),
		},
		{
			title: "Applied For",
			dataIndex: "appliedFor",
			key: "appliedFor",
			...getColumnSearchProps("appliedFor"),
		},
		{
			title: "State",
			dataIndex: "state",
			key: "state",
		},
		{
			title: "District",
			dataIndex: "district",
			key: "district",
		},
		{
			title: "Can Join from",
			dataIndex: "availableAfter",
			key: "availableAfter",
			...getColumnSearchProps("availableAfter"),
		},
		{
			title: "Received",
			dataIndex: "createdAt",
			key: "createdAt",
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					record={record}
					confirm={confirm}
					update="false"
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Application Removing has been cancelled"
					linkUrl={`/careers/applications`}
					placeholder="Please enter reason to delete application"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.career?.applications.filter((item) => item === "delete")?.length > 0
							? "true"
							: false
					}
					view={
						permissionArr === "all"
							? "true"
							: permissionArr?.career?.applications.filter((item) => item === "read")?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];

	const fileName = formatFileName("applications", "xlsx",admin);
	let downloadData = [];
	if (dataSource.length > 0) {
		downloadData = applications.map((application) => {
			return Object.assign({}, application, {
				hasAccepted: "true",
				job: application.job ? application.job.position : "",
			});
		});
	}

	const handleError = (error) => {
		message.error(error.message);
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : (permissionArr?.career?.applications?.filter((item) => item === "export")?.length >
							0 && downloadData?.length !== 0) ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : null}
				</div>
				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Applications Received: ${applications.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default Applications;
